"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AddressAutoComplete = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../../../hooks");
var _AutoComplete = require("../AutoComplete");
var _autoCompleteResultsPropTypes = require("../../../../../propTypes/autoCompleteResultsPropTypes");
var _formFieldPropTypes = require("../../../../../propTypes/formFieldPropTypes");
require("../AutoComplete.scss");
const _excluded = ["onSelectWithData", "customTrackingData", "customTrackingEvents"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const AddressResultMarkup = _ref => {
  let {
    result,
    clickHandler,
    customTrackingData,
    customTrackingEvents
  } = _ref;
  const {
    mainText,
    reference,
    secondaryText
  } = result;
  const resultButton = (0, _react.useRef)(null);
  (0, _hooks.useTracking)({
    elementRef: resultButton,
    trackingProps: {
      label: 'Address list selection',
      field: {
        inputType: 'button'
      }
    },
    customTrackingData,
    customTrackingEvents
  });
  return /*#__PURE__*/_react.default.createElement("button", {
    ref: resultButton,
    type: "button",
    key: reference,
    value: reference,
    onClick: () => clickHandler({
      result,
      selectedValue: mainText,
      inputValue: mainText
    })
  }, /*#__PURE__*/_react.default.createElement("strong", null, mainText), /*#__PURE__*/_react.default.createElement("span", null, secondaryText));
};
AddressResultMarkup.propTypes = _autoCompleteResultsPropTypes.AddressAutoCompleteResultsPropTypes;
const AddressAutoComplete = _ref2 => {
  let {
      onSelectWithData,
      customTrackingData,
      customTrackingEvents
    } = _ref2,
    customProps = _objectWithoutProperties(_ref2, _excluded);
  const srInstruction = "Use this input to search for an address.\n        A list of addresses will be created below that can be accessed using the tab key\n        and selected using Enter or Space.";
  return /*#__PURE__*/_react.default.createElement(_AutoComplete.AutoComplete, _extends({
    ResultMarkup: AddressResultMarkup,
    resultMarkupExtraProps: {
      customTrackingData,
      customTrackingEvents
    },
    srInstruction: srInstruction,
    resultMarkupValueKey: "reference"
  }, customProps));
};
exports.AddressAutoComplete = AddressAutoComplete;
AddressAutoComplete.propTypes = _formFieldPropTypes.AutoCompletePropTypes;
AddressAutoComplete.defaultProps = _objectSpread(_objectSpread({}, _formFieldPropTypes.FormFieldDefaultProps), {}, {
  minCharacters: 3
});
var _default = exports.default = AddressAutoComplete;